module.exports = __webpack_public_path__ + "static/media/send-email.d6e84978.svg";